// Base redirect URI (domain only, no path prefix)
export const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI ?? 'http://localhost:3000';
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID ?? '85a97398-9523-46c4-8188-54a255afd0f1';
export const FEATURE_FLAG = Number(import.meta.env.VITE_FEATURE_FLAG ?? '19968');

// Normalize the preview path once so all route and redirect builders use the
// same slash convention (for example, /PR918).
const rawUrlPrefix = import.meta.env.VITE_URL_PREFIX ?? '/wt';
export const URL_PREFIX = (() => {
  const segments = rawUrlPrefix.trim().split('/').filter(Boolean);
  return segments.length ? `/${segments.join('/')}` : '';
})();

// Full app base URL combines the stable preview origin with the PR path.
let baseUri = REDIRECT_URI;
while (baseUri.endsWith('/')) {
  baseUri = baseUri.slice(0, -1);
}
export const APP_BASE_URL = `${baseUri}${URL_PREFIX}`;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'https://watchtower-develop.ab-inbev.com';

// US redirect URL - where users are redirected when selecting US country
export const US_REDIRECT_URL: string =
  (import.meta.env.VITE_US_REDIRECT_URL as string) ?? 'https://watchtower-develop.ab-inbev.com/';

export const DEFAULT_API_URL = API_BASE_URL + (import.meta.env.VITE_API_BR ?? '/br/api/');
export const API_URL_CO = API_BASE_URL + (import.meta.env.VITE_API_CO ?? '/co/api/');

// VITE_API_PATH lets local dev point every country at the one local backend (`/wt/api`) via
// .env.local, with no source edit to revert before commit. Unset in deploy envs, so prod keeps
// the per-country `/${countryCode}/api/` routing that nginx maps upstream.
export const getApiUrl = (countryCode: string) => {
  const apiPath = (import.meta.env.VITE_API_PATH as string | undefined) ?? `/${countryCode}/api/`;
  return `${API_BASE_URL}${apiPath}`.toLowerCase();
};

export const GLOBAL_API_URL = (import.meta.env.VITE_API_GLOBAL as string) ?? `${API_BASE_URL}/wt/global/api`;

export const AUTH_TOKEN_KEY = 'Auth_token';
export const ACCESS_TOKEN_KEY = 'Access_token';
